// components/LoadingBackdrop.js
import React from 'react';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';

const LoadingBackdrop = ({ message = 'Loading...' }) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: 'blur(5px)',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2
            }}
            open={true}
        >
            <Fade in={true} timeout={800}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2
                }}>
                    <CircularProgress
                        color="inherit"
                        size={60}
                        thickness={4}
                        sx={{
                            boxShadow: '0 0 20px rgba(255, 255, 255, 0.2)',
                            borderRadius: '50%',
                        }}
                    />
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 500,
                            letterSpacing: 1,
                            textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                            animation: 'pulse 1.5s infinite',
                            '@keyframes pulse': {
                                '0%': { opacity: 0.7 },
                                '50%': { opacity: 1 },
                                '100%': { opacity: 0.7 },
                            },
                        }}
                    >
                        {message}
                    </Typography>
                </Box>
            </Fade>
        </Backdrop>
    );
};

LoadingBackdrop.propTypes = {
    message: PropTypes.string
};

export default LoadingBackdrop;